export default {
  meta_data: {
    schema: {
      type: 'object',
      properties: {
        icd10s: {
          name: 'icd10s',
          type: 'string',
          condition: {
            parentField: 'attendance',
            parentValue: 'attended',
          },
        },
        icd10_primary_diagnosis: {
          name: 'icd10_primary_diagnosis',
          type: 'array',
          validation: {
            isRequired: true,
          },
          condition: {
            parentField: 'attendance',
            parentValue: 'attended',
          },
        },
        icd10_secondary_diagnosis: {
          name: 'icd10_secondary_diagnosis',
          type: 'array',
          condition: {
            parentField: 'attendance',
            parentValue: 'attended',
          },
        },
      },
    },
    uiSchema: {
      'ui:order': ['icd10s', 'icd10_primary_diagnosis', 'icd10_secondary_diagnosis'],
      icd10s: {
        'ui:field': 'icd10s',
      },
      icd10_primary_diagnosis: {
        'ui:widget': 'hidden',
      },
      icd10_secondary_diagnosis: {
        'ui:widget': 'hidden',
      },
    },
    initialValues: {
      is_health_plan: true,
    },
  },
}
